import PropTypes from "prop-types";
import { productShape } from "app/utils/propTypes";
import { MerchandisingCard } from "../merchandising/MerchandisingCard";
import ProductFull from "@brand/Product/default/ProductFull";
import { LISTING_ITEM_TYPES } from "app/constants";

const ListingItemFull = ({ product = {}, resolution, hideMerchandising, showSmartDPOnRootUrl }) => {
	if (product.type === LISTING_ITEM_TYPES.PRODUCT) {
		return (
			<ProductFull
				resolution={resolution}
				product={product}
				showSmartDPOnRootUrl={showSmartDPOnRootUrl}
			/>
		);
	} else if (!hideMerchandising) {
		return <MerchandisingCard product={product} resolution={resolution} />;
	}
	return false;
};

ListingItemFull.propTypes = {
	product: productShape,
	resolution: PropTypes.string,
	hideMerchandising: PropTypes.bool,
	showSmartDPOnRootUrl: PropTypes.bool,
};

export default ListingItemFull;
